<template>
    <div id="v-categories" class="c-subcategories__filter" v-if="isCreated" v-cloak ref="root">
        <div v-if="selectedCategoryId" class="sc-back">
            <button
                class="c-btn c-btn--primary"
                v-if="showBackButton"
                @click.prevent="back"
                :title="backButtonName"
            >
                <i class="ico ico-arrow-left is-on-left"></i>&nbsp;{{ backButtonName }}
            </button>
        </div>

        <div class="c-subcategories__list">
            <div
                class="c-subcategories__item"
                v-for="category in categories"
                v-bind:key="category.id"
            >
                <div class="c-categories__info">
                    <a
                        :href="category.link"
                        :title="category.menu_name ? category.menu_name : category.name"
                        :class="{
                            'c-btn': true,
                            'is-active': category.id == selectedCategoryId,
                        }"
                        @click.prevent="change(category.id)"
                    >
                        <div class="sc-image" v-show="false">
                            <img
                                class="c-img"
                                :src="projectThumbnail(category.image, 'ret-category-thumb')"
                                :alt="category.name"
                            />
                        </div>

                        <span class="sc-name">
                            {{ category.menu_name ? category.menu_name : category.name }}
                        </span>
                        <span class="sc-count" v-if="category.count !== null">
                            {{ category.count }}
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CategoriesFilter from "./../../../../vendor/rshop/frontend/assets/js/components/CategoriesFilter";
import { thumbnail as projectThumb } from "../../functions/thumbnail";
import client from "./../../../../vendor/rshop/frontend/assets/js/common/client";

export default {
    name: "CategoriesFilter",
    extends: CategoriesFilter,
    methods: {
        projectThumbnail(src, format) {
            return projectThumb(src, format);
        },
        fetchCategories() {
            let data = {
                select: this.forceSiblingsView ? "siblings" : "children",
            };

            if (this.selectedCategoryId) {
                data.category_id = this.selectedCategoryId;
            }

            if (this.productsCategories.length) {
                data.products_categories = this.productsCategories;
            }

            if (window.filterType) {
                data.filter_type = window.filterType;
            }

            this.isLoading = true;
            return client.post("/catalog/get-categories-tree", data).then((response) => {
                // selected category doesnt have any subcategories
                if (response.data.categories.length > 0) {
                    this.categories = response.data.categories;
                }

                this.selectedCategory = response.data.selected_category;
                document.querySelector(this.filterSelector).dispatchEvent(
                    new CustomEvent("category.updated", {
                        detail: {
                            category: response.data.selected_category,
                        },
                    })
                );

                this.isLoading = false;
                this.forceSiblingsView = false;
                this.actualView = response.data.view;
                this.parent = response.data.parent;
            });
        },
    },
    computed: {
        backButtonName() {
            if (!this.selectedCategory) {
                return "";
            }

            if (this.actualView == "siblings" && this.parent) {
                return this.parent.name;
            }

            return this.selectedCategory.name;
        },
    },
};
</script>
